<template>
    <div>
        <form>
            <div class="row">
                <div class="col-sm-3">
                    <div class="mb-3">
                        <label>RFC</label>
                        <input class="form-control" type="text" v-model="form.rfc" v-bind:class="formSubmitted ? errors.rfc ? 'is-invalid' : 'is-valid' : ''" placeholder="" required="" @input="form.rfc = form.rfc.toUpperCase()">
                        <div class="invalid-feedback" v-if="errors.rfc">{{ errors.rfc }}</div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="mb-3">
                        <label>CURP</label>
                        <input class="form-control" type="text" v-model="form.curp" v-bind:class="formSubmitted ? errors.curp ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.curp = form.curp.toUpperCase()">
                        <div class="invalid-feedback" v-if="errors.curp">{{ errors.curp }}</div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="mb-3">
                        <label>NSS</label>
                        <input class="form-control" type="text" v-model="form.nss" v-bind:class="formSubmitted ? errors.nss ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.nss = form.nss.toUpperCase()">
                        <div class="invalid-feedback" v-if="errors.nss">{{ errors.nss }}</div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="mb-3">
                        <label>Fecha de Alta</label>
                        <Datepicker class="datepicker-here form-control digits dp2" @update:modelValue="changeDate" v-model="form.initial_date" :enable-time-picker="false" :locale="'es-MX'" :format-locale="es" format="dd/MM/yyyy"></Datepicker>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>S.D</label>
                        <input class="form-control" type="text" v-model="form.daily_salary" placeholder="" v-bind:class="formSubmitted ? errors.daily_salary ? 'is-invalid' : 'is-valid' : ''" @input="calculate()">
                        <div class="invalid-feedback" v-if="errors.daily_salary != false">{{ errors.daily_salary }}</div>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>S.D.I</label>
                        <input class="form-control" type="text" v-model="form.integral_daily_salary" placeholder="" disabled>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>I.S.R</label>
                        <input class="form-control" type="text" v-model="form.isr" placeholder="" disabled>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>I.M.S.S</label>
                        <input class="form-control" type="text" v-model="form.imss" placeholder="" disabled>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>Infonavit</label>
                        <input class="form-control" type="text" v-model="form.infonavit" placeholder="" @input="calculate()">
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>Fonacot</label>
                        <input class="form-control" type="text" v-model="form.fonacot" placeholder="" @input="calculate()">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>Pago Fiscal</label>
                        <input class="form-control" type="text" v-model="form.salary_fiscal" placeholder="" disabled v-bind:class="formSubmitted ? errors.salary_fiscal ? 'is-invalid' : 'is-valid' : ''">
                        <div class="invalid-feedback" v-if="errors.salary_fiscal != false">{{ errors.salary_fiscal }}</div>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>Pago Fiscal Neto</label>
                        <input class="form-control" type="text" v-model="form.net_fiscal" placeholder="" disabled v-bind:class="formSubmitted ? errors.net_fiscal ? 'is-invalid' : 'is-valid' : ''">
                        <div class="invalid-feedback" v-if="errors.net_fiscal != false">{{ errors.net_fiscal }}</div>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>Pago Complementario</label>
                        <input class="form-control" type="text" v-model="form.net_complementary" placeholder="" disabled>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>Pago Total</label>
                        <input class="form-control" type="text" v-model="form.net_final" placeholder="" disabled>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>Banco</label>
                        <select class="form-select" v-model="form.bank">
                            <option v-for="(bank, index) in banks" :key="index" :value="bank.name">{{ bank.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>Cuenta / Clabe Interbancaria</label>
                        <input class="form-control" type="text" v-model="form.clabe" placeholder="">
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>

import validations from "@/mixins/validations/employeeValidations";
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

import moment from "moment";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { es } from 'date-fns/locale'

import ws from '@/services/employees'

export default {
    name: 'employee_salary_tab',
    mixins: [validations, modalCleanupMixin],
    components: {
        Datepicker
    },
    data(){
        return{
            employee: null,
            tabulator: null,
            banks: []
        }
    },
    beforeMount: async function() {
        let response = await ws.getBanks(); 

        if(response.type == "success"){
            this.banks = response.data;
        }
    },
    methods: {
        async loadEmployee(employee){
            this.employee = employee;
            
            this.setForm(this.employee);

            this.calculate();
        },
        changeDate(event){
            const today = moment();
            const initial = moment(event);
            const years = today.diff(initial, 'years');

            let vacations = 12;
            switch(years){
                case 0: vacations = 12; break;
                case 1: vacations = 14; break;
                case 2: vacations = 16; break;
                case 3: vacations = 18; break;
                case 4: vacations = 20; break;
                case 5: case 6: case 7: case 8: case 9: vacations = 22; break;
                case 10: case 11: case 12: case 13: case 14: vacations = 24; break;
                case 15: case 16: case 17: case 18: case 19: vacations = 26; break;
                case 20: case 21: case 22: case 23: case 24: vacations = 28; break;
                case 25: case 26: case 27: case 28: case 29: vacations = 30; break;
                case 30: case 31: case 32: case 33: case 34: vacations = 32; break;
            }

            const factor = 1 + (15 / 365) + ((vacations * 0.25) / 365);

            this.form.work_age = years + 1;
            this.form.integration_factor = factor;
            this.form.integral_daily_salary = (this.form.daily_salary * this.form.integration_factor).toFixed(2);

            this.calculate();
        },
        async updateSalaryEmployee(form) {
            let response = await ws.updateEmployee(form);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.$emit('refresh', response.data);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        async calculate(){
            this.form.integral_daily_salary = (this.form.daily_salary * this.form.integration_factor).toFixed(2);

            this.form.payroll = 0;

            let response2 = await ws.tabulatorEmployee(this.form.daily_salary, 4);

            if(response2.type == "success"){
                this.tabulator = response2.data;
                this.$emit('tabulator', response2.data);

                this.form.isr = (this.tabulator.daily_isr * this.form.total_work_days).toFixed(2);
            }

            let response3 = await ws.imssEmployee(this.form.daily_salary, this.form.work_age, this.form.total_work_days);

            console.log(response3);

            if(response3.type == "success"){
                this.tabulator = response3.data;

                let data = response3.data;
                
                let integral_daily_salary = response3.data.integral_daily_salary;
                
                this.form.imss = (integral_daily_salary * (0.0025 + 0.00375 + 0.00625 + 0.01125) * this.form.total_work_days).toFixed(2);
                data.imss = this.form.imss;
                
                this.$emit('imss', data);

                this.form.integral_daily_salary = integral_daily_salary.toFixed(2);
                this.form.salary_fiscal = (this.form.daily_salary * 15).toFixed(2);
                this.form.net_fiscal = (this.form.daily_salary * 15 - this.form.isr - this.form.imss - this.form.infonavit - this.form.fonacot).toFixed(2);
                this.form.net_complementary = ((this.form.final_wage - this.form.net_fiscal) > 0 ? this.form.final_wage - this.form.net_fiscal : 0).toFixed(2);
            }

            // let response = await ws.calculateEmployee(this.form);

            // if(response.type == "success"){
            //     let data = response.data;
                
            //     this.form.net_fiscal = data.net_fiscal.toFixed(2);
            //     this.form.net_complementary = data.net_complementary.toFixed(2);
            //     this.form.net_final = data.net_final.toFixed(2);
            //     this.form.salary = data.salary.toFixed(2);
            // }
        },
        validations(){
            this.updateEmployeeSalaryValidation();
        }
    }
}
</script>